import { render, staticRenderFns } from "./ShopDetails.vue?vue&type=template&id=43157e90&"
import script from "./ShopDetails.vue?vue&type=script&lang=js&"
export * from "./ShopDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports